import React from 'react';

import ExtractByTypename from 'graphql-client/ExtractByTypename';
import {StudyOverviewViewQuery} from 'studies/workspace/overview/__generated/StudyOverviewViewQuery';

import ProcessDevelopmentStudyExecutionProgress from './ProcessDevelopmentStudyExecutionProgress';

type StudyNode = ExtractByTypename<StudyOverviewViewQuery['study'], 'StudyNode'>;

export default function ProcessDevelopmentStudyExecutionOverview({study}: {study: StudyNode}): JSX.Element {
  return <ProcessDevelopmentStudyExecutionProgress studyId={study.id} />;
}
